import { render } from "./date-group.vue?vue&type=template&id=0bce04c3&lang=pug"
import script from "./date-group.vue?vue&type=script&lang=js"
export * from "./date-group.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__